import { Tile } from '#src/components/series/SeriesBoard/HotStreakTile/Tile/index.tsx';
import { DiamondBaseColor } from '#src/components/series/SeriesBoard/HotStreakTile/Tile/utils.ts';

export const ReadyTile = () => {
  return <Tile color={DiamondBaseColor.orange} borderAnimated scaling />;
};
